// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5fce01cb","455":"a8178c04"}[chunkId] + ".chunk.js";
};